<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div class="l-contents">
      <h1 class="l-pageTitle">ソリューション</h1>
      <div class="l-btn-createnew_pos">
        <div class="btn-create-new_wh" @click="goInput()" :disabled="isProcessing"><a>新規作成</a></div>
      </div>
      <div class="l-contentsBox">
        <div class="l-grayBox mt-30">
          <div class="l-infoResult">
            <p><span>検索結果：</span>{{ pageInfo.total }}件</p>
          </div>
        </div>
        <table class="table-base audit-table table-select mt-30">
          <colgroup>
            <col style="width: 200px;">
            <col style="">
          </colgroup>
          <thead>
            <tr>
              <th>ソリューション名</th>
              <th>キャッチコピー</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="solution in solutionList" :key="solution.solutionId" @click="goEdit(solution.solutionId)">
              <td>{{ solution.name }}</td>
              <td>{{ solution.catchCopy }}</td>
            </tr>
          </tbody>
        </table>
        <pagination
          :pageInfo="pageInfo"
          @change-page="emitChangePage">
        </pagination>
      </div>
    </div>
  </main>
</template>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import Pagination from '@/components/parts/common/Pagination.vue';

export default {
  components: {
    Loading,
    Pagination,
  },
  data() {
    return {
      isProcessing: false,
      pageInfo: {},
      solutionList: []
    }
  },
  created: function () {
    this.getSolutionList(1);
  },
  methods: {
    emitChangePage(page) {
      this.getSolutionList(page)
    },
    async getSolutionList(page) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/master/solution/getSolutionList', {
        page: page,
      });
      if (res) {
        this.solutionList = res.data.solutionList.data;
        this.pageInfo = {
          currentPage: res.data.solutionList.currentPage,
          lastPage: res.data.solutionList.last_page,
          total: res.data.solutionList.total,
          from: res.data.solutionList.from,
          to: res.data.solutionList.to,
        };
      }
      this.isProcessing = false;
    },
    goInput() {
      this.$store.dispatch('master/setSolutionId', null);
      this.$router.push({ name: 'solution-master-new' });
    },
    goEdit(solutionId) {
      this.$store.dispatch('master/setSolutionId', solutionId);
      this.$router.push({ name: 'solution-master-edit' } );
    }
  }
}


</script>
